import React from 'react';

import {useI18n} from '@udemy/i18n';
import {AlertBanner} from '@udemy/react-messaging-components';

export const NoPlanAlertBanner = ({label = 'Personal Plan'}: {label?: string}) => {
    const {gettext, interpolate} = useI18n();
    return (
        <AlertBanner
            showCta={false}
            title={interpolate(
                gettext("We're working to make %(label)s available for more learners. Stay tuned."),
                {label},
                true,
            )}
        />
    );
};
